import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguagesService {

  constructor(protected http: HttpClient) { }

  list(): Observable<string> {
    return this.http.get<string>('/languages');
  }
}
